import './App.css';
import { Navigate, Route, Routes } from 'react-router';
import './style/css/reset.css'
import './style/css/sidebar.css'
import './style/css/style.css'
import './style/css/zone.css'
import Login from './Pages/Login';
import { ProtectedRoute } from './Components/ProtectedRoute';
import Filmroom from './Pages/Filmroom';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'

function App() {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <div className="App">
        <Routes>
          <Route path='/login' element={<Login />} />
          <Route path='/filmroom' element={<ProtectedRoute element={<Filmroom />} />} />
          <Route path='*' element={<Navigate to='/login' replace />} />
        </Routes>
      </div>
    </LocalizationProvider>
  );
}

export default App;
